import React from 'react';
import './index.css';
import './Loading.module.css';

const Loading = () => {
  return (
    <div style={{
      minHeight: '70vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '1.2rem'
    }}>
      <div style={{ position: 'relative', width: 52, height: 52 }}>
        <svg viewBox="0 0 56 56" width="52" height="52"
          style={{ animation: 'spin 1.2s linear infinite' }}
          xmlns="http://www.w3.org/2000/svg">
          <circle cx="28" cy="28" r="22" fill="none" stroke="#e0e0e0" strokeWidth="4"/>
          <circle cx="28" cy="28" r="22" fill="none" stroke="#333" strokeWidth="4"
            strokeDasharray="80 60" strokeLinecap="round"
            transform="rotate(-90 28 28)"/>
        </svg>
      </div>
      <p style={{ margin: 0, fontSize: 15, color: '#888', letterSpacing: '0.03em' }}>
        Loading...
      </p>

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default Loading;